
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://otwraixtzelqephcxktv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im90d3JhaXh0emVscWVwaGN4a3R2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDExOTEyMjksImV4cCI6MjA1Njc2NzIyOX0.m53WTVj_cFfqZBA2wLrS0sNb5gAaoCaEmJyS-rVdL-A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
